'use client';

import { createContext, useState, useEffect, useContext, useMemo } from 'react';

interface AccordionContextType {
	defaultValue?: string;
	activeValue?: string;
	setActiveValue: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const AccordionContext = createContext<AccordionContextType>({
	defaultValue: undefined,
	activeValue: undefined,
	setActiveValue: () => {}
});

export function AccordionProvider({ 
	defaultValue,
	children
}: { 
	defaultValue?: string;
	children: React.ReactNode;
}) {
	const [activeValue, setActiveValue] = useState<string | undefined>(defaultValue);

	useEffect(() => {
		setActiveValue(defaultValue);
	}, [defaultValue]);

	const value = useMemo(() => ({ 
		defaultValue, 
		activeValue,
		setActiveValue
	}), [defaultValue, activeValue]);

	return (
		<AccordionContext.Provider value={value}>
			{children}
		</AccordionContext.Provider>
	);
}

export const useAccordionContext = () => useContext(AccordionContext);